<template>
  <div class="content-blocks">
    <p v-for="(block, i) in blocks" :key="i" class="content-block-p">
      <template v-for="(part, j) in block.parts">
        <router-link v-if="part.link" :key="'l-' + i + '-' + j" :to="normalizeTo(part.link.to)">
          <strong v-if="part.strong">{{ part.link.text }}</strong>
          <template v-else>{{ part.link.text }}</template>
        </router-link>
        <strong v-else-if="part.strong" :key="'s-' + i + '-' + j">{{ part.text }}</strong>
        <span v-else :key="'t-' + i + '-' + j">{{ part.text }}</span>
      </template>
    </p>
  </div>
</template>

<script>
import { withTrailingSlash } from '@/utils/route-path';

export default {
	name: 'ContentBlocks',
	methods: {
		normalizeTo(to) {
			return withTrailingSlash(to);
		},
	},
	props: {
		blocks: {
			type: Array,
			default: () => [],
		},
	},
};
</script>
